export default "__VITE_ASSET__BEwVuRWS__"